import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getStakeholders = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("stakeholders", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postStakeholder = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("stakeholders", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putStakeholder = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ STAKEHOLDER_ID: id });
    const response = await serverApi.put(`stakeholders`, payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
